var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mic-permission"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"text"},[_vm._v("Favor de permitirnos el acceso a tu micrófono")])])])
}]

export { render, staticRenderFns }